<template>
  <span class="relative-date">
    {{ relative }}
    <Tooltip position="left">
      {{ absolute }}
    </Tooltip>
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { date as dateUtil } from 'quasar'
import { formatRelativeDate } from '@/helpers'
import { useRelativeNow } from '@/composables'

defineOptions({ name: 'RelativeDate' })
const props = defineProps({
  date: { type: [String, Date], required: true }
})

const { formatDate } = dateUtil
const now = useRelativeNow()

const target = computed(() => props.date instanceof Date ? props.date : new Date(props.date))
const relative = computed(() => formatRelativeDate(target.value, now.value))
const absolute = computed(() => formatDate(target.value, 'DD MMM YYYY HH:mm'))
</script>

<style scoped>
@reference "#app-styles.css";

.relative-date {
  @apply block truncate w-full min-w-0 text-xs ink-soft;
}
</style>
